import React from 'react';
import ExternalSvg from 'components/ExternalSvg';
import { AshaIconProps } from '../types';

const AshaBread = ({ width = '24px', height = '24px' }: AshaIconProps) => (
  <ExternalSvg customer="asha" iconName="ashaBread" width={width} height={height} />
);

export default AshaBread;
